'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrphansContentModel = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2, _dec, _dec2, _dec3, _desc2, _value2, _class3, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

var _mobx = require('mobx');

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _collectionGridEditor = require('collection-grid-editor');

var _collectionGridEditor2 = _interopRequireDefault(_collectionGridEditor);

var _typeEntity = require('type-entity');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var OrphansContentModel = exports.OrphansContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(OrphansContentModel, _BaseContentModel);

  function OrphansContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OrphansContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OrphansContentModel.__proto__ || (0, _getPrototypeOf2.default)(OrphansContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.readonly = true, _this.savable = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OrphansContentModel, [{
    key: 'orphans',
    get: function get() {
      return this.$parent.entities.values().filter(function (e) {
        return !e.constructor.Synthetic && e.isOrphan;
      });
    }
  }]);
  return OrphansContentModel;
}(_baseContentmodel2.default), _class2.Synthetic = true, _class2._slots = {
  orphans: [_baseContentmodel2.default]
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'orphans', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'orphans'), _class.prototype)), _class);
var ContentModel = (_dec = _mobx.observable.shallow, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class3 = function () {
  function ContentModel() {
    var _this2 = this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, ContentModel);

    _initDefineProp(this, 'types', _descriptor, this);

    _initDefineProp(this, 'willLoad', _descriptor2, this);

    _initDefineProp(this, 'hasLoaded', _descriptor3, this);

    _initDefineProp(this, 'willHydrate', _descriptor4, this);

    _initDefineProp(this, 'hasHydrated', _descriptor5, this);

    _initDefineProp(this, 'hasHydratedProject', _descriptor6, this);

    this.entities = _mobx.observable.shallowMap({});

    if (!(process && process.env && process.env.localMode) && !opts.simgate) {
      throw new Error("content model requires a simgate instance");
    }
    if (!opts.webpackLoader) throw new Error("missing webpackLoader!");
    (0, _assign2.default)(this, opts);
    (0, _mobx.extendObservable)(this.types, this.getContentModels(this.webpackLoader));

    _baseContentmodel2.default.$parent = this;

    (0, _keys2.default)(this.types).filter(function (typeName) {
      return !_this2.types[typeName].Synthetic;
    }).forEach(function (typeName) {
      var type = _this2.types[typeName];
      var id = typeName;
      var typed = new _typeEntity.ContentModel({ id: id });
      _this2.entities.set(id, typed);
    });

    this.entities.set("Orphans", new OrphansContentModel({ id: "Orphans" }));
  }

  (0, _createClass3.default)(ContentModel, [{
    key: 'getContentModels',
    value: function getContentModels(loader) {
      var _this3 = this;

      var obj = {};
      loader.keys().forEach(function (k) {
        var module = loader(k);
        if (module.ContentModels) {
          (0, _keys2.default)(module.ContentModels).forEach(function (k2) {
            //do not attach default
            if (k2 === "default") return;
            // attach parent contentModel dictionary
            module.ContentModels[k2].$parent = _this3;
            obj[k2] = module.ContentModels[k2];
          });
        }
      });
      return obj;
    }
  }, {
    key: 'hydrateEntities',
    value: function hydrateEntities() {
      var _this4 = this;

      var contentModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.willHydrate = +new Date();
      // hydrate base entities into contentmodel
      var obj = (0, _keys2.default)(contentModel).reduce(function (acc, k) {
        var entity = contentModel[k];
        if (!entity || !entity.attr1) {
          console.log("entity rejected due to missing or broken JSON: " + entity.name);
          return acc;
        }

        var type = entity.tag;
        if (typeof entity.attr1 !== "string") throw new Error("malformed attr1" + entity.name);
        var data = void 0;

        try {
          data = JSON.parse(entity.attr1);
        } catch (e) {
          console.log("entity rejected due to broken JSON in attr1: " + entity.name);
          return acc;
        }

        data.guid = entity.id || "guid";
        var existingEntity = _this4.entities.get(k);
        if (existingEntity) {
          // if already registered
          existingEntity.populate(data);
          existingEntity._dateAdded = entity.dateAdded;
          existingEntity._dateEdited = entity.dateEdited;
          existingEntity._lastReview = entity.val;
        } else {
          var ItemContentModel = _this4.types[type];
          if (!ItemContentModel) {
            console.warn("missing contentmodel class for " + type);
            return acc;
          }
          acc[k] = new ItemContentModel(data, _this4.loaders);
          acc[k]._dateAdded = entity.dateAdded;
          acc[k]._dateEdited = entity.dateEdited;
          acc[k]._lastReview = entity.val;
        }
        return acc;
      }, {});

      var output = [];
      if ((0, _keys2.default)(obj).length) {
        this.entities.merge(obj);
        this.entities.keys(obj).forEach(function (k) {
          var ent = _this4.entities.get(k);
          ent.populate();
          output.push(ent);
        });
      }
      this.hasHydrated = +new Date();
      return output;
    }
  }, {
    key: 'loadEntities',
    value: function loadEntities(cb, errCb) {
      var _this5 = this;

      //overwritten in simgate-contentmodel.local.js
      if (this.isLoading) return cb && cb();
      this.willLoad = +new Date();

      // when loading in stage / prod, only use static entities.json
      if (window.trcAppSettings && window.trcAppSettings.environment !== 'dev' && window.trcAppSettings.environment !== 'qa' && window.trcAppSettings.environment !== 'demo' && window.trcAppSettings.environment !== 'authoring' && window.trcAppSettings.environment !== 'auth') {
        require.ensure("app/config/entities.json", function () {
          var entities = require("app/config/entities.json");
          if (!entities || !entities.entities || !entities.entities.length) throw new Error("content is missing!");
          entities = entities.entities;
          var ents = entities.reduce(function (acc, i) {
            return (acc[i.name] = i) && acc;
          }, {});
          _this5.hasLoaded = +new Date();
          _this5.hydrateEntities(ents);
          if (typeof cb === "function") cb(_this5);
        });
      } else {
        if (!this.simgate) throw new Error("missing simgate");

        var taskArgs = [this.simgate.execQuery, {
          "query": "simbox-queries://getall"
        }, {
          onSuccess: function onSuccess(res) {
            var ents = res && res.data && res.data[0] && res.data[0].reduce(function (acc, i) {
              return (acc[i.name] = i) && acc;
            }, {});
            _this5.hasLoaded = +new Date();
            _this5.hydrateEntities(ents || {});
            if (typeof cb === "function") cb(_this5);
          },
          onFailure: errCb
        }];

        if (this.simgate.runTask) {
          var _simgate;

          (_simgate = this.simgate).runTask.apply(_simgate, taskArgs);
        } else {
          this.simgate.execQuery(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
        }
      }
      return this;
    }
  }, {
    key: 'deleteAllEntities',
    value: function deleteAllEntities(cb, errCb, ents) {
      // const entities = ents.length ? ents : this.entities.values()
      // @TODO if ents provided, only delete those
      // @TODO we need a mechanism for tracking isolated entities, those perhaps can be deleted
      this.simgate.execQuery({
        "query": "simbox-queries://deleteall"
      }).then(cb).catch(errCb);
    }
  }]);
  return ContentModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class3.prototype, 'types', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return {
      //gets extended in constructor
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class3.prototype, 'willLoad', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, 'hasLoaded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'willHydrate', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'hasHydrated', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'hasHydratedProject', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'loadEntities', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'loadEntities'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'deleteAllEntities', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'deleteAllEntities'), _class3.prototype)), _class3));
exports.default = ContentModel;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrphansContentModel, 'OrphansContentModel', 'src/core_modules/simgate-contentmodel/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/core_modules/simgate-contentmodel/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/simgate-contentmodel/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/simgate-contentmodel/index.js
// module chunks = 0